const ClearBtnLabel = ({isNeeded}: {isNeeded: boolean}) => {
	if (!isNeeded) return <></>;

	return (
		<div className="service__clear-help">
			<p>Remove your image from all image formats below</p>
		</div>
	);
};

export default ClearBtnLabel;